import getRemBase from 'propel/getRemBase';

const setHeaderHeight = () => {
	const header = document.querySelector('.main-header');
	if (!header) {
		return;
	}

	const adminBar = document.getElementById('wpadminbar');

	let headerHeight = 0;
	let adminBarHeight = 0;

	const updateCssVar = () => {
		document.body.style.setProperty(
			'--header-height',
			`${(headerHeight + adminBarHeight) / getRemBase()}rem`
		);
	};

	// ResizeObserver callbacks fire after layout, so entry sizes are already
	// computed — reading them here avoids forcing a layout.
	const observer = new ResizeObserver((entries) => {
		for (const entry of entries) {
			const height =
				entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height;
			if (entry.target === header) {
				headerHeight = height;
			} else {
				adminBarHeight = height;
			}
		}
		updateCssVar();
	});

	observer.observe(header, { box: 'border-box' });

	if (adminBar) {
		observer.observe(adminBar, { box: 'border-box' });
	}
};

export default setHeaderHeight;
